module.exports = __webpack_public_path__ + "static/img/home_lb.828290c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home_lb.png
// module id = rMik
// module chunks = 0